/**
 * File Utility Functions
 * Common utilities for file operations across the application
 */

/**
 * Format bytes to human-readable file size
 * @param {number} bytes - File size in bytes
 * @returns {string} Formatted file size (e.g., "2.5 MB")
 */
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

/**
 * Validate file type
 * @param {File} file - File object to validate
 * @param {string[]} allowedTypes - Array of allowed MIME types or extensions
 * @returns {boolean} True if file type is allowed
 */
export const validateFileType = (file, allowedTypes = ['.pdf', '.doc', '.docx', '.rtf', '.xls', '.xlsx', '.odt', '.ods', '.txt', '.csv', '.jpg', '.jpeg', '.png', '.ppt', '.pptx', '.json']) => {
  const fileName = file.name.toLowerCase();
  return allowedTypes.some(type => fileName.endsWith(type.toLowerCase()));
};

/**
 * Get file extension from filename
 * @param {string} filename - File name
 * @returns {string} File extension without dot
 */
export const getFileExtension = (filename) => {
  return filename.split('.').pop()?.toLowerCase() || '';
};
